// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2kK77","content":"LoadingAlert_content__1hf_h"};